import React from 'react'

export const Context = React.createContext();


const Doc = (props) => {

      return (<React.Fragment>
<div className="doc">
<h2>Documentation</h2>

<p>HomeAndCo provides remote access to a filesystem, allowing to navigate in
directories and download, upload or share files</p>
<p>After login, you access the filesystem with your usual permissions.</p>

<h3>Files</h3>

<p>This page gives access to the remote file system and can be used to
list, download or upload files.</p>

<p>All configured directories are accessible (can be your home directory but also other group or public directories).
Some directories may be in read-only mode.</p>

<p>To navigate in directories, you can click on directory icon to go in this directory.
Question mark icon can give further information on the directory (permissions etc..).</p>

<p>When listing a directory (depending on size can take a few seconds), you have the list of
subdirectories and files.</p>
<ul>
    <li>Question mark icon will give file/dir information</li>
    <li>Trash icon will delete file or recursively delete directory content</li>
    <li>Download icon will ... download the file</li>
    <li>Move icon (files only) will move a file to an other directory. Once clicked, go to expected destination, path and move confirmation are found at the top of the table</li>
    <li>Edit icon opens a file in LibreOffice for supported file types (can be used with other users for collaborative edition)</li>
    <li>Share icon opens a dialog where you name the link you want to create, the permissions and the expiration time. An url with a token will be shown after creation and can be sent to people you want to share the file/dir with</li>
</ul>

<h4>Shares</h4>

<p>Once you get a share link, the url can be used by anyone to access a file or a directory (and all its sub content).
Read-write shares should be used with care!!!</p>

<p>Users with this link do not need to have an account and will see only the shared file/directory. From here they can browse and download files.</p>
<p>After expiration time, user will not have access anymore</p>

<p>Tokens can also be used with tools like curl to download files, simply setting in URL headers <em>Authorization: Bearer YOURTOKEN</em> and url https://.../api/files/xxxx (xxxx = path to the file)</p>

<h4>Webdav access</h4>

<p>It is also possible to access filesystem via webdav (to mount disk on linux or windows as a remote disk), using url: davs://homeandco.genouest.org/api/webdav. You will be prompted for login/password.</p>
<p>For webdav access with shared links, use *anonymous* for login, and the token as password (https://...?token=**token**)</p>

<h3>Objects</h3>

<p>This page gives access to an object store (Openstack switf) and can be used to
list, download or upload files.</p>


<h3>Shares</h3>

<p>This page lists the files already shared with a public link and their expiration.
It is possible to revoke a link to prevent further usage.</p>

<p>You can also share in this page in filesystem path with an other known user or group.
Shares can be read-only (the default) or with write access.</p>

<p>Shares can be removed at any time.</p>

<h3>Managing access</h3>
<p>It is possible to deny remote access via homeandco. To do so, create a file named .homeandco.deny in a dir, this dir and subdirs won't have remote web access</p>
<p>You can also create static web sites (html pages) with public access (anyone with url can view it).</p>
<p>Accessing https://.../web/file_path will give public (anonymous) access to a file or directory if base directory or parent directory contains a file named <em>homeandco.public</em>.</p>
<p>If path is a directory and contains an index.html it will be served, making possible to host a static web site</p>

<h3>Command line</h3>
<p>Using curl:</p>

      <p># with TOKEN an environment variable with token to access file /home/homeandco/myfile</p>
      <pre><code>curl -H "Authorization: Bearer $TOKEN"  'https://homeandco.genouest.org/api/download/home/homeandco/myfile'</code></pre>
      <p>OR</p>
      <pre><code>curl 'https://homeandco.genouest.org/api/download/home/homeandco/myfile?token=$TOKEN'</code></pre>

<p>Using get:</p>
      <p># download directory content recursively, with TOKEN an environment variable with token to access directory /home/homeandco/test/</p>
      <p># Caution to ending slash for directories</p>
      <pre><code>wget --header="Authorization: Bearer $TOKEN"  -r --no-parent -R "index.html*"  https://homeandco.genouest.org/api/download/home/homeandco/test/</code></pre>

<p>A command line tool can be used to list/download/upload files or directories.</p>
<p>Binary can be downloaded at <a href="https://gitlab.inria.fr/genouest/r-d/homeandco/-/releases">https://gitlab.inria.fr/genouest/r-d/homeandco/-/releases</a> with Hac command line client for your platform (linux, mac, windows).</p>

      <pre><code>export HAC_URL=https://homeandco.genouest.org</code></pre>
      <pre><code># Using credentials</code></pre>
      <pre><code>export HAC_USER=my_user_login</code></pre>
      <pre><code>export HAC_PASSWORD=my_password</code></pre>
      <pre><code># OR</code></pre>
      <pre><code>export HAC_TOKEN=xxxx if using a share token</code></pre>
      <pre><code>./hac ls path_to_my_home</code></pre>
      <pre><code>./hac cp --from hac://path_to_remote_file_or_directory_to_download --to path_to_local_directory</code></pre>
      <pre><code>./hac cp --from path_to_local_file_or_directory_to_upload --to hac://path_to_remote_directory</code></pre>

<p>On windows, to set environment variables:</p>
<code>
      $env:HAC_URL='https://homeandco.genouest.org'
</code>
</div>
      </React.Fragment>)
}

export default Doc;